import React, { useContext, useState, useEffect } from "react";

// import ShareProfileImg from "../../assets/images/shareProfile.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

import { Carousel } from "react-bootstrap";
// import { axiosInstance_agent } from "../../axiosInstance-agent";
import { toast } from "react-toastify";
import { axiosInstance_agent } from "../axiosInstance-agent";
import profilePlaceholder from "../assets/images/profile-placeholder.jpg";

export function ViewMatchmakerDetails() {
  const [profileData, setProfileData] = useState({});

  const location = useLocation();
  const { id } = location.state || {};

  console.log("Id", id);
  const navigate = useNavigate();

  async function LoadProfile(id) {
    try {
      const response = await axiosInstance_agent.get(`/Agent/${id}`);
      if (response.data.status === true || response.status === 200) {
        setProfileData(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch data!");
      console.log("failed to fetch data");
    }
  }
  useEffect(() => {
    LoadProfile(id);
  }, [id]);
  return (
    <div className="viewmoreBg shareProfile-container">
      <div className="container">
        <div className="agency-name d-flex">
          {" "}
          <div
            onClick={() => navigate("/matchmakers", {})}
            style={{ color: "#2B171B", marginRight: "10px" ,cursor:'pointer'}}
          >
            {" "}
            <span>
              <BsArrowLeft />
            </span>
          </div>
          {/* {agency ? agency : "Nathicharami Agency"} */}
          {/* Agent Name :{profileData.full_name} */}
          Agency Name : {(profileData.agency_name===null || profileData.agency_name==="null" ||profileData.agency_name==="" )? "Nathicharami Agency" :profileData.agency_name}
          <span style={{ color: "#524f4f", marginLeft: "10px" }}>
            {/* {matchmakerName ?? "__"} */}
          </span>
        </div>
        <div className="share-title">Bio Data</div>
        <div className="view-container">
          <div className="viewImg">
            <div className="altprofileviewImg">
              <img src={profileData.profile_pic?profileData.profile_pic:profilePlaceholder} alt="No profile available" />
            </div>
          </div>
          <div className="shareProfile-name">{profileData.full_name}</div>
          <div className="view-subcontainer">
            <div className="view-subcontainer-left">
              <div className="shareprofile-subtitle">Basic Details :</div>
              <div className="profile-detailsContainer">
                <div>First Name</div>
                <div>:</div>

                <div>{profileData.first_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Last Name</div>
                <div>:</div>
                <div>{profileData.last_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Email</div>
                <div>:</div>
                <div>{profileData.email}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Mobile</div>
                <div>:</div>
                <div>{profileData.mobile}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Profession</div>
                <div>:</div>
                <div>
                  {profileData.categories?.map((c) => (
                    <div key={c.id}>{c.name}</div>
                  ))}
                </div>
              </div>
              <div className="profile-detailsContainer">
                <div>Agency Name</div>
                <div>:</div>
                <div>{profileData.agency_name ?? "Nathicharami Agency"}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Aadhaar/PAN</div>
                <div>:</div>
                <div className="viewImg">
                  <div className="altprofileviewImg">
                    <img
                      src={profileData.document}
                      alt="No profile available"
                    />
                  </div>
                </div>
              </div>

              <div className="shareprofile-subtitle mt-3">More Details:</div>
              <div className="profile-detailsContainer">
                <div>About</div>
                <div>:</div>
                <div>{profileData.about}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Terms & Conditions</div>
                <div>:</div>
                <div>{profileData.terms_condition}</div>
              </div>

              <div className="shareprofile-subtitle mt-3">Bank Details :</div>
              <div className="profile-detailsContainer">
                <div> Bank Account Number</div>
                <div>:</div>
                <div>{profileData.account_number}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>IFSC Code</div>
                <div>:</div>
                <div>{profileData.ifsc_code ?? "---"}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Bank Name</div>
                <div>:</div>
                <div>{profileData.bank ?? "---"}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
